<template>
  <div id="tabLclUnitLoadDevice" style="height:100%;display: flex;flex-direction: column;">
    <cargo-up-down-resize
      class="app-main-inner"
      :up-style="{display: 'flex', flexDirection: 'column', paddingBottom: '5px'}"
      :down-style="{display: 'flex', flexDirection: 'column',paddingTop:'5px'}"
      style="height: 100%"
    >
      <template slot="up">
        <div v-show="readonly && viewSource!=='salesDetail'" class="section">
          <div>
            <el-button no="1" type="primary" @click="pm.addSlaveHandler()">{{ $t('SeaExport.AddTickets') }}</el-button>
            <el-button no="2" type="danger" @click="pm.removeSlaveHandler()">{{ $t('SeaExport.RemoveTickets') }}</el-button>
          </div>
        </div>
        <div class="section" style="flex-grow:1">
          <cargo-ag-grid
            no="3"
            :grid-options="gridOptions"
            :grid-params.sync="gridParams"
            :column-defs="columnDefs"
            :row-data="lclSlaves"
            style="width:100%;height:100%"
            @gridReady="params=>gridApi=params.api"
          />
        </div>
        <div style="padding:5px 0">
          <div style="float:left">
            <el-button v-show="isEdit" no="4" type="info" plain style="color:green" @click="pm.addToUnitLoadDeviceHandler()">↓</el-button>
            <el-button v-show="isEdit" no="5" type="info" plain style="color:red" @click="pm.removeToUnitLoadDeviceHandler()">↑</el-button>
          </div>
          <div style="float:right">
            <el-form :inline="true" label-width="55px" label-position="left">
              <el-form-item :label="totalLabel.package" class="custom">
                <span>{{ slaveTotalDesc.slaveTotalQuantity }}</span>
              </el-form-item>
              <el-form-item :label="$t('SeaExport.TotalNumberOfPackages')" class="custom">
                <span>{{ slaveTotalDesc.slaveTotalWeight }}</span>
              </el-form-item>
              <el-form-item :label="$t('SeaExport.TotalCubage')" class="custom">
                <span>{{ slaveTotalDesc.slaveTotalCubage }}</span>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </template>
      <template slot="down">
        <cargo-left-right-resize
          :left-style="{display: 'flex', flexDirection: 'column',width:'20%'}"
          :right-style="{display: 'flex', flexDirection: 'column',width:'80%'}"
          style="height: 100%;min-height: 300px"
        >
          <template slot="left">
            <cargo-ag-grid
              no="6"
              :grid-options="left.gridOptions"
              :grid-params.sync="left.gridParams"
              :column-defs="unitLoadDeviceColumnDefs"
              :row-data="unitLoadDevices"
              style="height:100%"
              @gridReady="params=>left.gridApi=params.api"
            />
          </template>
          <template slot="right">
            <div class="section" style="flex: 1;">
              <cargo-ag-grid
                no="7"
                :grid-options="right.gridOptions"
                :grid-params.sync="right.gridParams"
                :column-defs="usageColumnDefs"
                :row-data="selectedUnitLoadDevice.unitLoadDeviceUsage"
                style="flex-grow:1"
                @gridReady="params=>right.gridApi=params.api"
              />
            </div>
            <div style="padding:5px 0">
              <div style="float:left">
                <span>{{ usagesTotalDesc.txtNum }}</span>
              </div>
              <div style="float:right">
                <el-form :inline="true" label-width="55px" label-position="left">
                  <el-form-item :label="totalLabel.package" class="custom">
                    <span>{{ usagesTotalDesc.usageTotalQuantity }}</span>
                  </el-form-item>
                  <el-form-item :label="totalLabel.weight" class="custom">
                    <span>{{ usagesTotalDesc.usageTotalWeight }}</span>
                  </el-form-item>
                  <el-form-item :label="totalLabel.cubage" class="custom">
                    <span>{{ usagesTotalDesc.usageTotalCubage }}</span>
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </template>
        </cargo-left-right-resize>
      </template>
    </cargo-up-down-resize>
    <!-- 加入拼箱工作单查询弹窗 -->
    <query-ae-lcl-dialog
      :visible.sync="queryAeLclDialog.visible"
      :job="job"
      @attachSubJobCallBackHandler="rows=>{pm.slaveAddedHandler(rows)}"
    />
  </div>
</template>

<script>

import cargoUpDownResize from '@/components/Cargo/Common/cargoUpDownResize'
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ContainerNoHelper from '@/utils/containerNoHelper'
import * as NumberUtils from '@/utils/NumberUtils'
import { Job } from '@/class/model/booking/Job'
import { formatNumberToThousands } from '@/utils'
import { isNumber } from '@/utils/validate'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import QueryLclDialog from '@/components/Cargo/Job/queryLclDialog'
import CargoAgGridDateTimeEditor from '@/components/Cargo/Common/CargoAgGridDateTimeEditor'
import { UnitLoadDeviceUtil } from '@/class/cargo/model/utils/UnitLoadDeviceUtil'
import { TabLclUnitLoadDeviceBase } from './tabLclUnitLoadDeviceBase'
import QueryAeLclDialog from '@/components/Cargo/Job/queryAeLclDialog'
import { UnitLoadDevice } from '@/class/model/booking/UnitLoadDevice'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import CargoAgGridCommonTextareaEditor from '@/components/Cargo/Common/CargoAgGridCommonTextareaEditor'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { TabError } from '@/utils/class/TabError'
import { LOG_AE_AIR_BOOKING } from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'TabLclUnitLoadDevice',
  components: { QueryAeLclDialog, QueryLclDialog, cargoUpDownResize, cargoLeftRightResize },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    viewSource: { // 页面请求发起方
      type: String,
      required: false
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      pm: new TabLclUnitLoadDeviceBase(this),
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        suppressRowSelection: false,
        suppressRowClickSelection: false,
        rowMultiSelectWithClick: false,
        context: {
          componentParent: this
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onCellFocused(event)
        },
        onRowClicked: this.onRowClicked
      },
      columnDefs: [
        {
          headerName: this.$t('SeaExport.BusinessNo'),
          field: 'jobNo',
          width: 150
        },
        {
          headerName: this.$t('SeaExport.WarehouseNo'),
          field: 'warehouseNo',
          width: 120
        },
        {
          headerName: 'MAWB No.',
          field: 'mbl',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.ConsignationCompany'),
          field: 'customerId',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.PortOfDestination'),
          field: 'destinationPortCode',
          width: 130,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: this.$t('SeaExport.FinalPlaceOfDelivery'),
          field: 'destinationPlace',
          width: 130
        },
        {
          headerName: 'ETD',
          field: 'etd',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.ChineseDescriptionOfGoods'),
          field: 'cargoChineseName',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.PackageType'),
          field: 'packing',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.Quantity'),
          width: 100,
          cellRenderer: (params) => {
            return this.slaveQuantityLabelFunc(params.data)
          }
        },
        {
          headerName: this.$t('SeaExport.GrossWeight'),
          width: 100,
          cellRenderer: (params) => {
            return this.slaveWeightLabelFunc(params.data)
          }
        },
        {
          headerName: this.$t('SeaExport.Cubage'),
          width: 100,
          cellRenderer: (params) => {
            return this.slaveCubageLabelFunc(params.data)
          }
        }
      ],
      gridApi: null,
      left: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          singleClickEdit: true,
          suppressCellSelection: true,
          frameworkComponents: { // 添加编辑组件
            CargoAgGridDateTimeEditor,
            CargoAgGridCommonInputEditor
          },
          context: {
            componentParent: this
          },
          // 选中 勾选框或者其他列 都会触发
          onCellFocused: (event) => {
            this.onCellFocusedUnitLoadDevice(event)
          },
          onRowClicked: this.unitLoadDeviceChangeHandler
        },
        gridApi: null
      },
      right: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          suppressRowSelection: false,
          suppressRowClickSelection: false,
          rowMultiSelectWithClick: false,
          context: {
            componentParent: this
          },
          frameworkComponents: { // 添加编辑组件
            CargoAgGridCommonInputEditor,
            CargoAgGridCommonTextareaEditor
          }
        },
        gridApi: null
      },
      boxNoDialog: {
        visible: false
      },
      queryAeLclDialog: {
        visible: false
      },
      unitLoadDeviceUsageColl: [], // 装箱信息
      selectedUnitLoadDevice: new UnitLoadDevice().fillDefaultValue().getData(), // 选中的箱子
      job: new Job().fillDefaultValue().getData(),
      unitLoadDevices: [], // 箱子列表
      lclSlaves: [],
      lclSlavesMap: {},
      slaveTotalDesc: { // 合计汇总
        slaveTotalQuantity: '',
        slaveTotalWeight: '',
        slaveTotalCubage: ''
      },
      usagesTotalDesc: { // 合计汇总
        txtNum: '',
        usageTotalQuantity: '',
        usageTotalWeight: '',
        usageTotalCubage: ''
      },
      totalLabel: { // 合计汇总label
        package: this.$t('SeaExport.TotalNumberOfPackages') + ':',
        weight: this.$t('SeaExport.TotalWeight') + ':',
        cubage: this.$t('SeaExport.TotalCubage') + ':'
      },
      operationTipsAarry: [], // 记录修改的 operationTips
      selectedSlave: {}, // 选中的小票
      updateLclSlaves: new Set(), // 需要更新小票
      location: LOG_AE_AIR_BOOKING.code
    }
  },
  computed: {
    readonly() {
      return this.action === 'look'
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    // 显示拆分主票按钮
    showSplitButton() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    unitLoadDeviceColumnDefs() {
      const columnDefs = [
        {
          headerName: '',
          field: '',
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ApplicableContainerType'),
          colId: 'containerType',
          field: 'containerType',
          width: 100,
          valueFormatter: params => {
            return CommonState.getNameByCode(SystemConstants.AIRPLANE_CONTAINER_TYPES, params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ApplicableContainerCode'),
          colId: 'containerCode',
          field: 'containerCode',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ApplicableContainerNumber'),
          colId: 'containerNumber',
          field: 'containerNumber',
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          width: 100,
          onCellValueChanged: p => {
            this.unitLoadDeviceItemEditEndHandler(p)
            this.onUnitLoadDeviceChange(p)
          }
        },
        {
          headerName: this.$t('SeaExport.Quantity'),
          field: 'quantity',
          width: 100,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 0
            }
          }
        },
        {
          headerName: this.$t('CargoMsg.cargo_pallet'),
          colId: 'board',
          field: 'board',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'el-checkbox'
          }
        },
        {
          headerName: this.$t('CargoMsg.cargo_container_max_weight') + '（KG）',
          colId: 'cargoWeight',
          field: 'cargoWeight',
          width: 100,
          valueFormatter: params => ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_AirplaneContainer, 'code', params.data.containerCode, 'cargoWeight')
        },
        {
          headerName: this.$t('CargoMsg.cargo_container_max_capacity') + '（m³）',
          colId: 'cargoCapacity',
          field: 'cargoCapacity',
          width: 100,
          valueFormatter: params => ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_AirplaneContainer, 'code', params.data.containerCode, 'cargoCapacity')
        }
      ]

      return columnDefs
    },
    usageColumnDefs() {
      const columnDefs = [
        {
          headerName: this.$t('SeaExport.SequenceNumber'),
          field: 'serialNo',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: this.isEdit ? 'el-input-number' : 'span',
            precision: 0,
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        {
          headerName: this.$t('SeaExport.BusinessNo'),
          field: 'jobNo',
          width: 150
        },
        {
          headerName: this.$t('SeaExport.WarehouseNo'),
          field: 'warehouseNo',
          width: 120
        },
        {
          headerName: 'MAWB No.',
          field: 'mbl',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.ConsignationCompany'),
          field: 'customerId',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.Quantity'),
          field: 'quantity',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              type: 'number',
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val))
              },
              checkInput: (val) => {
                // 空值允许删除
                if (!val) return true
                return isNumber(val)
              }
            },
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        {
          headerName: this.$t('SeaExport.GrossWeight'),
          field: 'weight',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              type: 'number',
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 3))
              },
              checkInput: (val) => {
                // 空值允许删除
                if (!val) return true
                return isNumber(val)
              }
            },
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        {
          headerName: this.$t('SeaExport.Cubage'),
          field: 'cubage',
          width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              type: 'number',
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 3))
              },
              checkInput: (val) => {
                // 空值允许删除
                if (!val) return true
                return isNumber(val)
              }
            },
            valueChanged: p => { this.onCellChange(p) }
          }
        },
        {
          headerName: this.$t('SeaExport.EnglishDescriptionOfGoods'),
          colId: 'cargoEnglishName',
          field: 'cargoEnglishName',
          width: 120,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonTextareaEditor',
          onCellValueChanged: p => this.onJobCellChange(p),
          valueFormatter: params => this.onSlaveLabel(params)
        },
        {
          headerName: this.$t('SeaExport.OnBoardRequirements'),
          colId: 'loadReq',
          field: 'loadReq',
          width: 120,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonTextareaEditor',
          onCellValueChanged: p => this.onJobCellChange(p),
          valueFormatter: params => this.onSlaveLabel(params)
        },
        {
          headerName: this.$t('SeaExport.SpaceRquirement'),
          colId: 'cabinReq',
          field: 'cabinReq',
          width: 120,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonTextareaEditor',
          onCellValueChanged: p => this.onJobCellChange(p),
          valueFormatter: params => this.onSlaveLabel(params)
        },
        {
          headerName: this.$t('SeaExport.CargoSize'),
          colId: 'measurements',
          field: 'measurements',
          width: 120,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonTextareaEditor',
          onCellValueChanged: p => this.onJobCellChange(p),
          valueFormatter: params => this.onSlaveLabel(params)
        }
      ]
      return columnDefs
    },
    config() {
      return this.context.config
    }
  },
  created() {
  },
  methods: {
    async onShow(row, isRefresh) {
      if (!isRefresh) {
        return
      }

      this.updateLclSlaves = new Set()

      const job = new AirExportJob(row)
      // 复制，拆分 动作 无uuid
      if (row.uuid) {
        await Promise.all([
          job.getAirUld(),
          job.getLclSlaves(),
          job.getUnitLoadDevices()
        ])
        this.job = job
        if (job.airUld && job.airUld.length > 0 && (!job.unitLoadDevices || job.unitLoadDevices.length === 0)) {
          UnitLoadDeviceUtil.autoJustUnitLoadDeviceUsages(job)
        }
        if (!job.unitLoadDevices) {
          job.unitLoadDevices = []
        }
        this.unitLoadDevices = job.unitLoadDevices
        this.lclSlaves = this.job.lclSlaves
      } else {
        row.airUld = []
        row.lclSlaves = []
        row.unitLoadDevices = []
      }

      this.pm.commitProperties()
    },
    // 保存数据提交
    async getSubmitData() {
      // 海进cargo 保存未校验
      this.pm.validateForm()
      await this.checkWC()

      // todo 重新组装数据 过滤 unitLoadDevice.unitLoadDeviceUsages isDirty=true 至后端保存
      console.info('unitLoadDevices', this.job.unitLoadDevices)
      const lclSlaves = this.job.lclSlaves.filter(p => p.isDirty === true)
      if (lclSlaves && lclSlaves.length > 0) {
        for (const p of lclSlaves) {
          delete p.unitLoadDeviceUsages
        }
      }
      return {
        unitLoadDevices: this.job.unitLoadDevices, // .filter(p => p.isDirty === true),
        delUnitLoadDeviceUuids: this.job.delUnitLoadDeviceUuids, // 删除的箱子uuid
        delUnitLoadDeviceUsageUuids: this.job.delUnitLoadDeviceUsageUuids, // 删除的装箱uuid
        lclSlaves: this.job.lclSlaves.filter(p => p.isDirty === true) // 参数 UnitLoadDeviceUpdateJobQCW =1 时装箱修改 小票件毛体
      }
    },

    async checkWC() {
      // 装载计算
      if (this.job.unitLoadDevices && this.job.unitLoadDevices.length > 0) {
        for (const p of this.job.unitLoadDevices) {
          // 获取小票装箱信息
          const unitLoadDeviceUsages = p.unitLoadDeviceUsage
          if (!unitLoadDeviceUsages || unitLoadDeviceUsages.length === 0) {
            continue
          }
          // 计算重量体积
          let weight = 0
          let cubage = 0
          for (const usage of unitLoadDeviceUsages) {
            weight += NumberUtils.roundHalfUp(usage.weight, 3)
            cubage += NumberUtils.roundHalfUp(usage.cubage, 3)
          }
          // 校验重量、体积是否大于集装器可装货体积、重量
          // 获取集装器信息
          const containerCode = p.containerCode
          const item = getObjectByCache(basicCacheKeys.basic_data_AirplaneContainer, 'code', containerCode)
          if (item) {
            const names = []
            if (item.cargoWeight < weight) {
              names.push(this.$t('CargoMsg.Cargo_Weight'))
            }
            if (item.cargoCapacity < cubage) {
              names.push(this.$t('CargoMsg.Cargo_Cubage'))
            }
            let checkWeightOrCubage = true
            if (names.length > 0) {
              await this.$confirm(this.$t('CargoMsg.Cargo_CheckUldWeightOrCubage', [containerCode, names.join('/'), names.join('/')]),
                this.$t('Message.Tips'), {
                  confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
                  cancelButtonText: this.$t('CargoMsg.Cargo_No'),
                  type: 'warning'
                }).then(() => {
                checkWeightOrCubage = true
              }).catch(() => {
                for (const usage of unitLoadDeviceUsages) {
                  usage.weight = 0.0
                  usage.cubage = 0.0
                }
                checkWeightOrCubage = false
              })
              if (!checkWeightOrCubage) {
                this.gridApi.refreshCells({ force: true })
                throw new TabError('', 'tabLclUnitLoadDevice')
              }
            }
          }
        }
      }
    },
    // 箱子列编辑
    unitLoadDeviceItemEditEndHandler(params) {
      params.data.isDirty = true // 用于校验数据是否修改标识
      if (params.field === 'sealNo') {
        params.data.isReSealed = true // 此属性赋值未用上
      }
    },
    // 列编辑修改事件 (usageItemEditEndHandler)
    onCellChange(params) {
      const usage = params.data
      if (!usage) {
        return
      }

      console.info('onCellChange', this.job.unitLoadDevices)
      // 同步更新unitLoadDevice的 usage
      for (const item of this.job.unitLoadDevices) {
        let bFlag = false
        for (const itemUsage of item.unitLoadDeviceUsage) {
          if (itemUsage === usage) {
            item.isDirty = true
            bFlag = true
            break
          }
        }
        if (bFlag) {
          break
        }
      }
      usage.isDirty = true // 用于校验数据是否修改标识
      this.pm.refreshSalves()
      this.right.gridOptions.api.refreshCells({ force: true })
    },
    // 列编辑修改事件 (usageItemEditEndHandler)
    onJobCellChange(params) {
      const usage = params.data
      if (!usage) {
        return
      }

      const field = params.hasOwnProperty('field') ? params.field : params.colDef.field
      // 修改小票数据
      if (field === 'cargoEnglishName' ||
        field === 'loadReq' ||
        field === 'cabinReq' ||
        field === 'measurements') {
        // 查找到对应的 lclSlave
        const lclJob = this.job.lclSlaves.find(p => p.uuid === usage.jobUuid)
        if (lclJob) {
          lclJob.isDirty = true
          lclJob[field] = params.data[field]
        }
        this.right.gridOptions.api.refreshCells({ force: true })
        return
      }
    },
    onUnitLoadDeviceChange(params) {
      const unitLoadDevice = params.data
      if (!unitLoadDevice) {
        return
      }
      const key = params.colDef.field || params.colDef.colId
      switch (key) {
        case 'containerNo':
          unitLoadDevice.syncToExport = true
          break
        case 'destinationDeliveryTime':
          unitLoadDevice.syncToExport = true
          break
        case 'destinationReturnTime':
          unitLoadDevice.syncToExport = true
          break
        default :
          break
      }
    },
    executeTask() {
      if (this.job && this.job.unitLoadDevices) {
        const unitLoadDevices = this.job.unitLoadDevices.filter(p => p.containerNo && p.syncToExport === true)
        if (this.job.trustFromJob && unitLoadDevices !== null && unitLoadDevices.length > 0) {
          syncContainersToExport(unitLoadDevices)
        }
      }
    },
    unitLoadDeviceNbrStyleFunction(unitLoadDevice) {
      if (unitLoadDevice) {
        if (!ContainerNoHelper.checkContainerNo(unitLoadDevice.containerNo)) {
          return 'data-red'
        }
      }
      return ''
    },
    slaveQuantityLabelFunc(data) {
      return this.pm.getItemLeft(data)
    },
    slaveWeightLabelFunc(data) {
      return NumberUtils.formatNumber(this.pm.getWeightLeft(data), 2)
    },
    slaveCubageLabelFunc(data) {
      return NumberUtils.formatNumber(this.pm.getCubageLeft(data), 3)
    },

    unitLoadDeviceChangeHandler(event) {
      this.pm.unitLoadDeviceChangeHandler(event)
    },
    // 小票行选中
    onRowClicked(event) {
      this.selectedSlave = event.data
    },
    onCellFocused(event) {
      if (this.gridOptions.api && event.column) {
        this.gridOptions.api.forEachNode(node => {
          if (node.rowIndex === event.rowIndex) {
            this.selectedSlave = node.data
          }
        })
      }
    },
    onCellFocusedUnitLoadDevice(event) {
      if (this.left.gridOptions.api && event.column) {
        this.left.gridOptions.api.forEachNode(node => {
          if (node.rowIndex === event.rowIndex) {
            this.selectedUnitLoadDevice = node.data
          }
        })
      }
    },
    getPrintData() {
      if (this.lclSlaves == null) return
      const job = this.job
      if (job && job.masterFlag) {
        const unitLoadDevices = this.gridApi.getSelectedRows()
        const params = {}
        if (unitLoadDevices.length === 0) {
          this.$message.warning('未勾选装箱信息')
          return null
        }
        if (unitLoadDevices.length === 1) {
          const unitLoadDevice = unitLoadDevices[0]
          params.CONTAINER_UUID = unitLoadDevice.uuid
          params.jobuuid = job ? job.uuid : ''
          params.job = job
          params.category = 'LCL'
          params.ctx = new AirExportJob(this.job)
        } else {
          const uids = []
          for (const c of unitLoadDevices) {
            uids.push(c.uuid)
          }
          params.CONTAINER_UUID = uids
          params.jobuuid = job ? job.uuid : ''
          params.job = job
          params.category = 'CONTAINER_LIST'
          params.ctx = new AirExportJob(this.job)
        }
        return params
      }
      return null
    },
    onSlaveLabel(params) {
      const usage = params.data
      if (!usage) {
        return ''
      }
      // 查找到对应的 lclSlave
      const lclJob = this.job.lclSlaves.find(p => p.uuid === usage.jobUuid)
      return lclJob ? lclJob[params.colDef.field] : ''
    }
  }
}
</script>

<style lang='scss'>
  .data-red {
    color: #FF0000;
  }
  .data-blue{
    color: #0000ff;
  }
  #tabLclUnitLoadDevice {
    .data-red {
      input.el-input__inner {
        color: #FF0000;
      }
    }
    .data-blue {
      input.el-input__inner {
        color: #0000ff;
      }
    }
  }
</style>
